export class ReponseReview {
  comment: string;
  score: number;
}
